import { Button } from "./button.js";

interface PaginationProps {
  readonly page: number;
  readonly pageCount: number;
  readonly pageSize: number;
  readonly onPageChange: (page: number) => void;
  readonly onPageSizeChange: (size: number) => void;
  readonly disabled?: boolean;
}

export function Pagination({
  page,
  pageCount,
  pageSize,
  onPageChange,
  onPageSizeChange,
  disabled = false,
}: PaginationProps) {
  return (
    <nav className="pagination" aria-label="Pagination">
      <label className="pagination__size">
        Rows per page
        <select
          value={pageSize}
          onChange={(event) => onPageSizeChange(Number(event.currentTarget.value))}
          disabled={disabled}
        >
          {[25, 50, 100].map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </label>
      <div className="pagination__controls">
        <Button tone="quiet" disabled={disabled || page === 1} onClick={() => onPageChange(1)}>
          <span aria-hidden="true">|‹</span> First
        </Button>
        <Button
          tone="quiet"
          disabled={disabled || page === 1}
          onClick={() => onPageChange(page - 1)}
        >
          <span aria-hidden="true">‹</span> Previous
        </Button>
        <span className="pagination__status" aria-live="polite">
          Page {page} of {pageCount}
        </span>
        <Button
          tone="quiet"
          disabled={disabled || page === pageCount}
          onClick={() => onPageChange(page + 1)}
        >
          Next <span aria-hidden="true">›</span>
        </Button>
        <Button
          tone="quiet"
          disabled={disabled || page === pageCount}
          onClick={() => onPageChange(pageCount)}
        >
          Last <span aria-hidden="true">›|</span>
        </Button>
      </div>
    </nav>
  );
}
